import { Paginated } from "../../../../common/domain/models/paginated_models";
import { AuditoresLista } from "../../domain/models/auditores_lista";
import { AuditorlListaFilter } from "../../domain/models/auditor_auditores_filter";
import { IAuditorRepository } from "../../domain/repositories/auditor_repository";
import { IAuditorService } from "../services/auditor_service";
import { AuditoriasLista } from "../../domain/models/auditorias_lista";
import { AuditoriasListaFilter } from "../../domain/models/auditor_auditorias_filter";
import { CreateAuditorAuditoriaResponse } from "../daos/create/create_auditor_auditoria";
import { ProcessoAuditoriasListaFilter } from "../../domain/models/auditor_processo_auditorias_filter";
import { ProcessoAuditoriasLista } from "../../domain/models/processo_auditorias_lista";
import { AuditoriaCopiaForm } from "../../presentation/schemas/Auditoria_auditoria/auditoria_copia";
import { CreateAuditorAuditoresResponse } from "../daos/create/create_auditor_auditores";
import { AuditoriaIndicadores } from "../../domain/models/auditoria_indicadores_lista";


export class AuditorRepository implements IAuditorRepository {
  constructor(private readonly service: IAuditorService) { }

  //#region Auditores
  async getAllListagemAuditores(
    filter: AuditorlListaFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<AuditoresLista>> {
    const response = await this.service.getAllListagemAuditores({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): AuditoresLista => ({
          IdAuditor: item.idAuditor,
          Cidade: item.cidade,
          TelCelular: item.telcelular,
          TelFixo: item.telfixo,
          Email: item.email,
          Nome: item.nome,
          Arquivo1: item.arquivo1,
          Arquivo2: item.arquivo2,
          Arquivo3: item.arquivo3,
          Arquivo4: item.arquivo4,
          Arquivo5: item.arquivo5,
          nomeArquivo1: item.nomearquivo1,
          nomeArquivo2: item.nomearquivo2,
          nomeArquivo3: item.nomearquivo3,
          nomeArquivo4: item.nomearquivo4,
          nomeArquivo5: item.nomearquivo5,
          TipoAuditor: item.tipoAuditor
        }),
      ),
    };
  }

  async createAuditores(
    Nome: string | null,
    TelFixo: string | null,
    TelCelular: string | null,
    Email: string | null,
    OutrasInformacoes: string | null,
    Cidade: string | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    Arquivo3: File | null,
    Arquivo4: File | null,
    Arquivo5: File | null,
    nomeArquivo1: string | null,
    nomeArquivo2: string | null,
    nomeArquivo3: string | null,
    nomeArquivo4: string | null,
    nomeArquivo5: string | null,
    TipoAuditor: number
  ): Promise<CreateAuditorAuditoresResponse> {
    const response = await this.service.createAuditores({
      Nome,
      TelFixo,
      TelCelular,
      Email,
      OutrasInformacoes,
      Cidade,
      Arquivo1,
      Arquivo2,
      Arquivo3,
      Arquivo4,
      Arquivo5,
      nomeArquivo1,
      nomeArquivo2,
      nomeArquivo3,
      nomeArquivo4,
      nomeArquivo5,
      TipoAuditor
    });
    return response;
  }

  async updateAuditor(
    IdAuditor: number,
    Nome: string | null,
    TelFixo: string | null,
    TelCelular: string | null,
    Email: string | null,
    OutrasInformacoes: string | null,
    Cidade: string | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    Arquivo3: File | null,
    Arquivo4: File | null,
    Arquivo5: File | null,
    nomeArquivo1: string | null,
    nomeArquivo2: string | null,
    nomeArquivo3: string | null,
    nomeArquivo4: string | null,
    nomeArquivo5: string | null,
    limparArquivo1: boolean,
    limparArquivo2: boolean,
    limparArquivo3: boolean,
    limparArquivo4: boolean,
    limparArquivo5: boolean,
    TipoAuditor: number
  ): Promise<void> {
    await this.service.updateAuditor({
      IdAuditor,
      Nome,
      TelFixo,
      TelCelular,
      Email,
      OutrasInformacoes,
      Cidade,
      Arquivo1,
      Arquivo2,
      Arquivo3,
      Arquivo4,
      Arquivo5,
      nomeArquivo1,
      nomeArquivo2,
      nomeArquivo3,
      nomeArquivo4,
      nomeArquivo5,
      limparArquivo1,
      limparArquivo2,
      limparArquivo3,
      limparArquivo4,
      limparArquivo5,
      TipoAuditor
    });
  }

  async deleteAuditores(IdAuditor: number): Promise<void> {
    await this.service.deleteAuditores({ IdAuditor });
  }

  async getArquivo(idAuditores: number, imagePosition: number): Promise<Blob> {
    const response = await this.service.getArquivo({
      idAuditores,
      imagePosition,
    });
    return response;
  }

  //#endregion

  //#region Auditorias
  async getAllListagemAuditoria(
    filter: AuditoriasListaFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<AuditoriasLista>> {
    const response = await this.service.getAllListagemAuditoria({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): AuditoriasLista => ({
          IdAuditoria: item.idAuditoria,
          EmAberto: item.emAberto,
          TipoAuditoria: item.tipoAuditoria,
          Evento: item.evento,
          DataElaboracao: item.dataElaboracao,
          DataAuditoria: item.dataAuditoria,
          DataTermino: item.dataTermino,
          Arquivo1: item.arquivo1,
          Arquivo2: item.arquivo2,
          nomeArquivo1: item.nomearquivo1,
          nomeArquivo2: item.nomearquivo2,
          Criterio: item.criterio,
          IdAuditor1: item.idAuditor1,
          IdAuditor2: item.idAuditor2,
          IdAuditor3: item.idAuditor3,
        }),
      ),
    };
  }

  async createAuditoria(
    Evento: string | null,
    TipoAuditoria: number | null,
    EmAberto: boolean | null,
    DataElaboracao: Date | null,
    DataAuditoria: Date | null,
    DataTermino: Date | null,
    Criterio: string | null,
    Observacao: string | null,
    IdAuditor1: number | null,
    IdAuditor2: number | null,
    IdAuditor3: number | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    nomeArquivo1: string | null,
    nomeArquivo2: string | null,
  ): Promise<CreateAuditorAuditoriaResponse> {
    const response = await this.service.createAuditoria({
      Evento,
      TipoAuditoria,
      EmAberto,
      DataElaboracao,
      DataAuditoria,
      DataTermino,
      Criterio,
      Observacao,
      IdAuditor1,
      IdAuditor2,
      IdAuditor3,
      Arquivo1,
      Arquivo2,
      nomeArquivo1,
      nomeArquivo2,
    });
    return response;
  }

  async copiaAuditoria(form: AuditoriaCopiaForm): Promise<void> {
    await this.service.copiaAuditoria({
      ...form,
    });
  }

  async updateAuditoria(
    IdAuditoria: number,
    Evento: string | null,
    TipoAuditoria: number | null,
    EmAberto: boolean | null,
    DataElaboracao: Date | null,
    DataAuditoria: Date | null,
    DataTermino: Date | null,
    Criterio: string | null,
    Observacao: string | null,
    IdAuditor1: number | null,
    IdAuditor2: number | null,
    IdAuditor3: number | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    nomeArquivo1: string | null,
    nomeArquivo2: string | null,
    limparArquivo1: boolean,
    limparArquivo2: boolean
  ): Promise<void> {
    await this.service.updateAuditoria({
      IdAuditoria,
      Evento,
      TipoAuditoria,
      EmAberto,
      DataElaboracao,
      DataAuditoria,
      DataTermino,
      Criterio,
      Observacao,
      IdAuditor1,
      IdAuditor2,
      IdAuditor3,
      Arquivo1,
      Arquivo2,
      nomeArquivo1,
      nomeArquivo2,
      limparArquivo1,
      limparArquivo2
    });
  }

  async deleteAuditoria(IdAuditoria: number): Promise<void> {
    await this.service.deleteAuditoria({ IdAuditoria });
  }

  async getArquivoAuditoria(idAuditoria: number, imagePosition: number): Promise<Blob> {
    const response = await this.service.getArquivoAuditoria({
      idAuditoria,
      imagePosition,
    });
    return response;
  }

  //#endregion

  //#region Processo Auditoria

  async createProcessoAuditoria(
    IdAuditoria: number | null,
    Descricao: string | null,
    IdFuncionario: number | null,
    DescResponsavel: string | null,
    ResponsavelCadastrado: boolean | null,
    Data: Date | null,
    Horario: string | null,
    RequisitoNormativo: string | null,
    Local: number | null,
  ): Promise<void> {
    await this.service.createProcessoAuditoria({
      IdAuditoria,
      Descricao,
      IdFuncionario,
      DescResponsavel,
      ResponsavelCadastrado,
      Data,
      Horario,
      RequisitoNormativo,
      Local,
    });
  }
  async getAllListagemProcessoAuditoria(
    filter: ProcessoAuditoriasListaFilter,
    currentPage: number,
    rowsPerPage: number,
  ): Promise<Paginated<ProcessoAuditoriasLista>> {
    const response = await this.service.getAllListagemProcessoAuditoria({
      ...filter,
      currentPage,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ProcessoAuditoriasLista => ({
          IdAuditoria: item.idAuditoria,
          IdProcesso: item.idProcesso,
          Data: item.data,
          Horario: item.horario,
          Processo: item.descricao,
          RequisitoNormativo: item.requisitoNormativo,
          Responsavel: item.descResponsavel,
          FuncionarioNome: item.funcionarioNome,
          IdFuncionario: item.idFuncionario,
          ResponsavelCadastrado: item.responsavelCadastrado,
          Local: item.local,
          LocalNome: item.localNome,
        }),
      ),
    };
  }

  async updateProcessoAuditoria(
    IdProcesso: number,
    IdAuditoria: number,
    Descricao: string | null,
    IdFuncionario: number | null,
    DescResponsavel: string | null,
    ResponsavelCadastrado: boolean | null,
    Data: Date | null,
    Horario: string | null,
    RequisitoNormativo: string | null,
    Local: number | null,
  ): Promise<void> {
    await this.service.updateProcessoAuditoria({
      IdProcesso,
      IdAuditoria,
      Descricao,
      IdFuncionario,
      DescResponsavel,
      ResponsavelCadastrado,
      Data,
      Horario,
      RequisitoNormativo,
      Local,
    });
  }

  async deleteProcessoAuditoria(
    IdProcesso: number,
    IdAuditoria: number,
  ): Promise<void> {
    await this.service.deleteProcessoAuditoria({ IdProcesso, IdAuditoria });
  }

  async copiaProcessoAuditoria(
    IdProcesso: number,
    IdAuditoria: number,
    Descricao: string | null,
    IdFuncionario: number | null,
    DescResponsavel: string | null,
    ResponsavelCadastrado: boolean | null,
    Data: Date | null,
    Horario: string | null,
    RequisitoNormativo: string | null,
    Local: number | null,
  ): Promise<void> {
    await this.service.copiaProcessoAuditoria({
      IdProcesso,
      IdAuditoria,
      Descricao,
      IdFuncionario,
      DescResponsavel,
      ResponsavelCadastrado,
      Data,
      Horario,
      RequisitoNormativo,
      Local,
    });
  }

  //#endregion

  //#region Principal
  async getAllListagemIndicadores(): Promise<AuditoriaIndicadores> {
    const response = await this.service.getAllListagemIndicadores();
    return response.indicadores;
  }
  //#endregion
}
